import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const softwareSecurityNextGenRoute: InvariantJiraRoute = {
	name: 'software-security',
	path: '/jira/software/projects/:projectKey/security',
};
